export default {
    SalesOrderToBeApproved: {
        Pending: '寻源前待审核',
        reviewed: '发货前待审核',
        Order: '订单号',
        Tripartite: '客户订单号/内部订单号，多个逗号隔开',
        // Product: '商品名称/编码',
        SKU: 'SKU',
        source: '订单来源',
        nickname: '买家昵称',
        name: '收货人姓名',
        mobile: '收货人手机',
        Comments: '买家备注',
        Merchant: '商家备注',
        have: '有无赠品',
        placement: '三方下单时间',
        Start: '开始日期',
        End: '结束日期',
        Payment: '支付时间',
        Internal: '内部创单时间',
        Approved: '审核通过',
        Approval: '审核拒绝',
        deleteCache: '删除缓存',
        onOrderRetrieval: '订单找回',
        Please: '请输入分类名称',
        select: '请选择所属分类',
        code: '国家简称',
        form: {
            Third: '客户订单号',
            Internal: '内部订单号',
            Label: '标签',
            Approval: '审核状态',
            Sales: '销售店铺',
            channel: '销售渠道',
            Order: '订单来源',
            Product: '商品行数量',
            nickname: '买家昵称',
            comments: '买家备注',
            Merchant: '商家备注',
            Consignee: '收货人姓名',
            mobile: '收货人手机号',
            address: '收货人地址',
            Status: '发货状态',
            Receiving: '收货状态',
            Total: '商品总金额',
            payable: '买家应付',
            cost: '商品总成本',
            Three: '三方下单时间',
            Payment: '支付时间',
            document: 'ERP创单时间',
            Estimated: '预计发货时间',
            Pre: '预占状态',
            Sourcing: '寻源状态',
            Pending: '挂起状态',
            occupied: '预占回写状态',
            Shipment: '发货回写状态',
            there: '有无赠品',
            information: '商品信息',
            Please: '请选择审核数据',
            have: '您选中了已审核的订单',
            not: '您权限不足，无法审核选中的订单',
            Approved: '是否通过审核订单号',
            Reject: '是否拒绝审核订单号',
            Rejectpst: '审核拒绝',
            Rejectps: '不通过原因',
        }
    }
};
